export const COMPONENT_NAME = "settings-requisites-bank";
